import React, { useContext, useMemo } from 'react'
import _ from 'lodash'
import { Breadcrumbs as MuiBreadcrumbs, Theme } from '@mui/material'
import { breadcrumbsClasses } from '@mui/material/Breadcrumbs'
import { Link as RouterLink } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { getCategoryUrl } from '../../../urls'
import ProductContext from '../context/ProductContext'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) => ({
  breadcrumbs: {
    [`& .${breadcrumbsClasses.ol}`]: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflow: 'hidden',
    },
    [`& .${breadcrumbsClasses.li}, & .${breadcrumbsClasses.separator}`]: {
      whiteSpace: 'nowrap',
    },
    [`& .${breadcrumbsClasses.li}:last-child p, & .${breadcrumbsClasses.li}:last-child a`]: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      minWidth: 0,
    },
    [`& .${breadcrumbsClasses.li}:last-child`]: {
      minWidth: 0,
    },
  },
}))

const Breadcrumbs: React.FC = () => {
  const { reflection } = useContext(ProductContext)
  const classes = useStyles()

  const sortedCategories = useMemo(() => {
    const categories = _.sortBy(reflection.categories, node => node.level)
    const parent = categories.find(node => node.level === 0)

    return categories.map(cat => ({ ...cat, parent: cat.level > 0 ? parent : null }))
  }, [reflection.categories])

  return (
    <div className='pb-24 py-10'>
      <MuiBreadcrumbs maxItems={4} className={classes.breadcrumbs} classes={{ li: 'text-base md:text-lg' }}>
        {sortedCategories.map(node => {
          return (
            <Link
              key={node.id}
              component={RouterLink}
              color='#555555'
              to={
                node.parent
                  ? getCategoryUrl(node.parent.slug, node.parent.pk, [{ id: node.pk, slug: node.slug }])
                  : getCategoryUrl(node.slug, node.pk)
              }
              underline='hover'
            >
              {node.name}
            </Link>
          )
        })}
        <Typography color='gray'>{reflection.shortName || reflection.name}</Typography>
      </MuiBreadcrumbs>
    </div>
  )
}

export default Breadcrumbs
